import { allThemes, BoxProps, ColorOptions, IconNew, pincodeValidation, required, TextInputNewProps } from '@jfs/ui-new'
import { TextInputNew } from '../../../../components/AdminInputs'
import {
  GSTINValidation,
  notRequired,
  OptionalGSTINValidation,
  panOptionalValidation,
} from '@jfs/ui-new/src/utils/validations'
import { panValidation } from '@jfs/utils'
import * as Yup from 'yup'
import { Dropdown } from '../../../../components/Dropdown'
import { MccCode } from '../../../../components/MccCode'
import { getValueFromLOVDescription, LOV_CODES } from '../../../../utils'

import { DatePickerWithInfoIcon } from '../comps/DatePickerWithInfoIcon'
import { DropdownWithInfo } from '../comps/DropdownWithInfo'
import { Pincode } from '../comps/Pincode'
import { TextInputWithInfo } from '../comps/TextInputWithInfo'
import { UploadEntityFile } from '../comps/UploadEntityFile'
import { getDropdownData } from './dropdownData'
import { styles } from './styles'
import { addressValidation, hideNonExistantFields, Name } from './validations'
const hideCinComponent = (lovData: any) => (values: any) =>
  HIDE_CIN_FIELDS.includes(getValueFromLOVDescription(lovData, values?.ownershipType, 'OwnershipType'))

//(values: any) => HIDE_CIN_FIELDS.includes(values?.ownershipType) // hide if inividiual ownership
const hideGSTInputs = (lovData: any) => (values: any) =>
  ['P', 'NA'].includes(getValueFromLOVDescription(lovData, values?.gstCategory, 'MerchantCategory'))
const hidePhysicalChannelFields = (lovData: any) => (values: any) =>
  getValueFromLOVDescription(lovData, values?.businessChannel, 'BusinessChannel') !== LOV_CODES.PHYSICAL // hide of not physical merchant

export const businessDetailsForm = (dropDownData: any, editable: boolean, isStoreMerchant: boolean) => {
  const gstCategories = getDropdownData(dropDownData?.lovData, 'MerchantCategory')
  return {
    key: 'BUSINESS_DETAILS_FORM',
    verticalFlex: 1,
    contentOverflow: 'auto',
    horizontalFlex: 1,
    contentPadding: 24,
    title: 'Business Details',
    formItems: [
      {
        horizontalComps: [
          {
            fieldName: 'businessDisplayName',
            ComponentName: TextInputWithInfo,
            label: 'Business Display Name',
            placeholder: 'Business Display Name',
            validationSchema: isStoreMerchant ? notRequired : Name,
            ...styles.textinputStyle(editable),
            testID: 'businessDisplayName',
          },
          {
            fieldName: 'businessLegalName',
            ComponentName: TextInputWithInfo,
            label: 'Business Legal Name',
            placeholder: 'Business Legal Name',
            validationSchema: Name,
            ...styles.textinputStyle(editable),
            testID: 'businessLegalName',
          },
          {
            fieldName: 'storeType',
            ComponentName: DropdownWithInfo,
            label: 'Store Type ',
            title: 'Select Store Type ',
            validationSchema: isStoreMerchant ? notRequired : required,
            hideComponent: hidePhysicalChannelFields(dropDownData?.lovData),
            data: getDropdownData(dropDownData?.lovData, 'StoreType'),
            dataFieldToRead: 'description',
            ...styles.dropDownStyle(editable),
            testID: 'businessAddressType',
          },
        ],
        horizontalSpacing: 8,
      },

      {
        horizontalComps: [
          {
            fieldName: 'mccCodeComponent',
            ComponentName: MccCode,
            isEdit: editable,
            styles: styles,
            validationSchema: mccCodeValidation,
            coverFullWidth: true,
            childMarginRight: 16,
            textinputStyle: styles.textinputStyle(editable),
            dropDownMinHeight: 32,
            labelType: 'label',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'cinNumber',
            ComponentName: TextInputWithInfo,
            label: 'CIN Number (optional)',
            hideComponent: hideCinComponent(dropDownData?.lovData),
            placeholder: '',
            ...styles.textinputStyle(editable),
            testID: 'cinNumber',
          },
          {
            fieldName: 'companyIncorporatedDate',
            ComponentName: DatePickerWithInfoIcon,
            label: 'Company Incorporated Date (optional)',
            hideComponent: hideCinComponent(dropDownData?.lovData),
            placeholder: '',
            maxDate: new Date(),
            rightComponent: editable ? <IconNew id="CALENDAR" color={'PRIMARY'} /> : null,
            ...styles.datePickerStyle(editable),
            testID: 'companyIncorporatedDate',
          },
          {
            fieldName: 'yearsOfBusiness',
            ComponentName: DropdownWithInfo,
            label: 'Years of Business',
            title: 'Select Years of Business',
            data: getDropdownData(dropDownData?.lovData, 'YearsInBusiness'),
            dataFieldToRead: 'description',
            validationSchema: required,
            ...styles.dropDownStyle(editable),
            testID: 'yearsOfBusiness',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'storeCode',
            ComponentName: TextInputWithInfo,
            label: 'Store Code',
            validationSchema: storeCodeValidationSchema,
            hideComponent: hidePhysicalChannelFields(dropDownData?.lovData),
            placeholder: 'Enter Store Code',
            ...styles.textinputStyle(editable),
          },
          {
            fieldName: 'format',
            ComponentName: TextInputWithInfo,
            label: 'Format',
            hideComponent: hidePhysicalChannelFields(dropDownData?.lovData),
            validationSchema: formatValidationSchema,
            placeholder: 'Enter Format',
            ...styles.textinputStyle(editable),
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'businessPan',
            ComponentName: TextInputWithInfo,
            validationSchema: isStoreMerchant ? panOptionalValidation : panValidation,
            label: 'Business PAN ',
            placeholder: '',
            textFormatType: 'CAPITALIZED',
            ...styles.textinputStyle(editable),
            testID: 'cinNumber',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'gstCategory',
            ComponentName: DropdownWithInfo,
            label: 'GST Category',
            title: 'Select GST Category',
            validationSchema: isStoreMerchant ? notRequired : required,
            data: gstCategories,
            dataFieldToRead: 'description',
            ...styles.dropDownStyle(editable),
            testID: 'gstCategory',
          },
          {
            fieldName: 'gstinNumber',
            ComponentName: TextInputWithInfo,
            label: 'GSTIN Number',
            placeholder: '',
            textFormatType: 'CAPITALIZED',
            validationSchema: isStoreMerchant ? OptionalGSTINValidation : GSTINValidation,
            hideComponent: hideGSTInputs(dropDownData?.lovData),
            ...styles.textinputStyle(editable),
            testID: 'gstinNumber',
          },
          {
            fieldName: 'confirmGstinNumber',
            ComponentName: TextInputWithInfo,
            label: 'Confirm GSTIN Number',
            textFormatType: 'CAPITALIZED',
            hideComponent: hideGSTInputs(dropDownData?.lovData),
            hide: !editable,
            validationSchema: confirmGstinValidation,
            placeholder: '',
            ...styles.textinputStyle(editable),
            testID: 'confirmGstinNumber',
          },
        ],
        horizontalSpacing: 8,
      },

      {
        horizontalComps: [
          {
            fieldName: 'gstDealerCategory',
            ComponentName: DropdownWithInfo,
            label: 'GST Dealer Category',
            title: 'Select GST Dealer Category',
            validationSchema: isStoreMerchant ? notRequired : required,
            data: getDropdownData(dropDownData?.lovData, 'GSTDealerCategory'),
            dataFieldToRead: 'description',
            hideComponent: hideGSTInputs(dropDownData?.lovData),
            ...styles.dropDownStyle(editable),
            testID: 'gstDealerCategory',
          },
          {
            fieldName: 'typeOfBusiness',
            ComponentName: DropdownWithInfo,
            label: 'Type of Business',
            title: 'Select Type of Business',
            validationSchema: isStoreMerchant ? notRequired : required,
            selectable: editable,
            data: getDropdownData(dropDownData?.lovData, 'BusinessType'),
            hideComponent: hideGSTInputs(dropDownData?.lovData),
            dataFieldToRead: 'description',
            ...styles.dropDownStyle(editable),
            testID: 'typeOfBusiness',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        fieldName: 'businessDetailsPob',
        ComponentName: UploadEntityFile,
        isOptional: isStoreMerchant,
        uploadButtonTitle: 'Upload Supporting POB Documents',
        uploadDialogTitle: 'Upload Required Doc',
        nonEditableTitle: 'Selected POB Documents',
        uploadId: dropDownData?.uploadId,
        optionalFields: ['pobExpiryDate'],
        editable,
        documentCategoriesSupported: ['POB'],
        jdmsTableColumns: ['Document Category', 'Document Number', 'Date of Expiry', 'Action'],
        hideColumnsJdms: ['kycDocuments', 'documentCategory', 'MERCHANT_DOCUMENT_TYPE'],
        documentListHeaderMapper: [
          {
            key: 'NAME',
            header: 'File Name',
          },
          {
            key: 'MERCHANT_DOCUMENT_NAME',
            header: 'Doc Type',
          },
          {
            key: 'expiry',
            header: 'Expiry Date',
          },
          {
            key: 'documentNumber',
            header: 'Doc Id',
          },
          {
            key: '',
            header: '',
          },
        ],
        uploadFileReqMapper: {
          documentName: 'pobDocType',
          documentNumber: 'pobId',
          dateOfExpiry: 'pobExpiryDate',
          documentType: 'pobDocType',
        },
        uploadFileReqConstants: {
          documentCategory: 'POB',
          uploadType: 'ENTITY',
        },
        categoryFieldName: 'pobDocType',
        rowData: [
          {
            fieldName: 'pobDocType',
            ComponentName: Dropdown,
            label: 'Proof of Business (POB) - Document Type',
            title: 'Select Document Type',
            validationSchema: required,
            data: dropDownData?.pobData,
            minHeight: 32,
            fullWidthContent: true,
            labelType: 'label',
            testID: 'proofOfBusiness',
          },
          {
            fieldName: 'pobId',
            ComponentName: TextInputNew,
            label: 'POB ID',
            placeholder: '',
            validationSchema: required,
            ...styles.textinputStyle(editable),
            testID: 'pobId',
          },
          {
            fieldName: 'pobExpiryDate',
            ComponentName: DatePickerWithInfoIcon,
            label: 'POB Expiry Date',
            placeholder: '',
            minDate: new Date(),
            maxDate: new Date().setDate(new Date().getDate() + 365 * 100),
            ...styles.datePickerStyle(editable),
          },
        ],
      },
      {
        horizontalComps: [
          {
            fieldName: 'premiseType',
            ComponentName: DropdownWithInfo,
            label: 'Premise Type ',
            title: 'Select Premise Type ',
            validationSchema: isStoreMerchant ? notRequired : required,
            data: getDropdownData(dropDownData?.lovData, 'PremiseType'),
            dataFieldToRead: 'description',
            ...styles.dropDownStyle(editable),
            testID: 'businessAddressType',
          },
        ],
        horizontalSpacing: 8,
      },
      {
        horizontalComps: [
          {
            fieldName: 'addressLine1',
            ComponentName: TextInputWithInfo,
            label: 'Address Line 1',
            placeholder: '',
            validationSchema: addressValidation,
            ...styles.textinputStyle(editable),
            testID: 'addressLine1',
          },
          {
            fieldName: 'addressLine2',
            ComponentName: TextInputWithInfo,
            label: 'Address Line 2',
            placeholder: '',
            validationSchema: addressValidation,
            ...styles.textinputStyle(editable),
            testID: 'addressLine2',
          },
          {
            fieldName: 'pincode',
            ComponentName: Pincode,
            label: 'Pincode',
            placeholder: '',
            validationSchema: pincodeValidation,
            ...styles.textinputStyle(editable),
            testID: 'pincode',
            cityField: 'city',
            stateField: 'state',
          },
        ],
        horizontalSpacing: 8,
      },

      {
        horizontalComps: [
          {
            fieldName: 'city',
            ComponentName: TextInputWithInfo,
            label: 'City',
            placeholder: 'Enter City',
            validationSchema: required,
            hideComponent: hideNonExistantFields('city'),
            ...styles.textinputStyle(false),
            testID: 'city',
          },
          {
            fieldName: 'state',
            ComponentName: DropdownWithInfo,
            label: 'State',
            title: 'Select State',
            data: getDropdownData(dropDownData?.lovData, 'State'),
            hideComponent: hideNonExistantFields('state'),
            dataFieldToRead: 'description',
            validationSchema: required,
            ...styles.dropDownStyle(false),
            testID: 'state',
          },
        ],
        horizontalSpacing: 8,
      },
    ],
    onSubmit: async (values) => {},
  }
}

const mccCodeStyle = {
  container: {
    h: '100%',
    bg: 'TRANSPARENT',
    shadowRadius: 8,
    shadowColor: '#0000001F' as ColorOptions,
    borderRadius: 8,
    overflow: 'auto',
  } as BoxProps,
  innerContainer: {
    f: 1,
    justify: 'center',
    align: 'flex-start',
    flexDirection: 'row',
    marginTop: 98,
  } as BoxProps,
  searchContainer: {
    borderWidth: 1,
    p: 48,
    borderRadius: 4,
    borderColor: '#0070B61F' as ColorOptions,
    bg: '#0070B60A' as ColorOptions,
  } as BoxProps,
  textInputContainer: (error: boolean) =>
    ({
      flexDirection: 'row',
      borderColor: error ? 'ERROR' : 'BLUE_SHADE_PRIMARY',
      borderRadius: 4,
      borderWidth: 1,
      bg: 'WHITE',
    } as BoxProps),
  loadingContainer: { f: 1, flexDirection: 'row', justify: 'center', align: 'center', ph: 4 } as BoxProps,
  iconContainer: (isValid: boolean) =>
    ({
      bg: 'BLUE_SHADE_PRIMARY',
      h: 48,
      w: 48,
      underlayColor: 'TRANSPARENT',
      borderTopLeftRadius: 2,
      borderBottomLeftRadius: 2,
      borderTopRightRadius: 2,
      borderBottomRightRadius: 2,
      justify: 'center',
      disabled: !isValid,
      align: 'center',
    } as BoxProps),
  header: {
    flexDirection: 'row',
    p: 16,
    // justify: 'space-between',
    align: 'center',
    borderBottomWidth: 1,
    borderBottomColor: '#0000001F' as ColorOptions,
    h: 70,
  } as BoxProps,
  footer: {
    p: 16,
    direction: 'row',
    // justify: 'flex-end',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
    minHeight: 100,
    width: '100%',
  } as BoxProps,
  footerNonEntity: {
    p: 16,
    direction: 'row',
    justify: 'space-between',
    alignItems: 'center',
    borderTopWidth: 1,
    borderTopColor: '#0000001F' as ColorOptions,
    minHeight: 120,
  } as BoxProps,
  textinputStyle: (isEditMode: boolean) =>
    ({
      type: 'body12',
      borderColor: isEditMode ? ('#d1d3e2' as ColorOptions) : 'WHITE',
      labelPaddingBottom: 10,
      borderRadius: isEditMode ? 4 : 0,
      labelFontFamily: 'jiotype-bold',
      fontFamily: 'jiotype-medium',
      labelColor: '#757575' as ColorOptions,
      labelFontSize: 12,
      fontSize: 12,
      selectionColor: isEditMode ? 'BLUE' : 'TRANSPARENT',
      paddingVertical: 9,
      padddingHorizontal: 16,
      color: 'BLACK_21' as ColorOptions,
      onFocusBorderWidth: isEditMode ? 1 : 0,
    } as unknown as TextInputNewProps),
  buttonBgView: {
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#214796' as ColorOptions,
    underlayColor: 'PRIMARY_STORNG' as ColorOptions,
    height: 45,
    marginTop: 8,
    borderRadius: 4,
  } as BoxProps,
  formContainer: {
    ph: 16,
    pv: 16,
    backgroundColor: allThemes.light.colors.WHITE,
    borderRadius: 8,
    alignSelf: 'center',
    mt: 16,
    minWidth: 300,
    maxWidth: 480,
  } as BoxProps,
}
export const HIDE_CIN_FIELDS = [LOV_CODES.SOLE_TRADER, LOV_CODES.PARTNERSHIP, LOV_CODES.INDIVIDUAL] //['Sole Trader', 'Partnership', 'Individual']
const storeCodeValidationSchema = Yup.string()
  .trim()
  .test('storeCodeValidation', 'Please enter StoreCode!', function (value, ...extraData) {
    const { format } = this.parent
    return !format || value?.length > 0
  })

const formatValidationSchema = Yup.string()
  .trim()
  .test('formatValidation', 'Please enter format!', function (value, ...extraData) {
    const { storeCode } = this.parent
    return !storeCode || value?.length > 0
  })

const confirmGstinValidation = Yup.string()
  .trim()
  .matches(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}[A-Z\d]{1}[Z]{1}[A-Z\d]{1}$/, 'Invalid GSTIN')
  .nullable()
  .optional()
  .test('gstinNoConfirmation', 'GSTIN and Confirm GSTIN  Mismatch', function (value, ...extraData) {
    const { gstinNumber } = this.parent
    return !gstinNumber || gstinNumber === value
  })

const businessLineValidation = Yup.object().shape({
  key: Yup.string().required('Required!'),
  value: Yup.string().required('Required!'),
})

const mccCodeValidation = Yup.object().shape({
  mccCode: Yup.string().trim().required('Invalid Mcc code!'),
  businessCategory: Yup.string().trim().required('Required!'),
  businessLine: businessLineValidation.required('Required!'),
})
